import { createContext, useContext, useEffect, useState } from "react";

const TextSizeContext = createContext(null);

export function TextSizeProvider({ children }) {
  const [big, setBig] = useState(() => localStorage.getItem("a2g_big_text") === "1");

  useEffect(() => {
    document.documentElement.classList.toggle("reading-big", big);
    localStorage.setItem("a2g_big_text", big ? "1" : "0");
  }, [big]);

  const value = { big, toggle: () => setBig((v) => !v), setSize: (v) => setBig(!!v) };
  return <TextSizeContext.Provider value={value}>{children}</TextSizeContext.Provider>;
}

export const useTextSize = () => useContext(TextSizeContext);
